import { jsx as _jsx } from "react/jsx-runtime";
export default function WorkflowStepHelpImage(props) {
    return (_jsx("img", { src: props.url, alt: "Sample", style: {
            maxWidth: "250px",
            maxHeight: "250px",
            objectFit: "contain",
            border: "1px solid #aaa"
        } }, void 0));
}
